import { Search } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useMyCommunitiesUi } from './myCommunitiesStore';

/**
 * The Communities hub search. Rendered inside the TopNav center slot on desktop
 * and bound to the shared UI store used by the page filters.
 */
export function CommunitiesHeader({ className }: { className?: string }) {
  const search = useMyCommunitiesUi((s) => s.search);
  const setSearch = useMyCommunitiesUi((s) => s.setSearch);

  return (
    <div className={cn('flex min-w-0 items-center justify-end', className)}>
      <label className="relative block w-full max-w-[250px]">
        <Search
          size={14}
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-lo"
        />
        <input
          type="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search..."
          aria-label="Search your communities"
          className="h-9 w-full rounded-pill border border-card-line bg-white/[0.04] pl-8 pr-3 text-[13px] font-medium text-hi outline-none transition-colors placeholder:text-lo focus:border-white/25 focus:bg-white/[0.06]"
        />
      </label>
    </div>
  );
}
